<template>
    <div>
        <GmapMap class="mainmap"
                 :center="this.centerMap"
                 :zoom="zoom"
                 map-type-id="terrain"
                 style="max-width: 720px; height: 400px"
                 :options="mapOptions"
                 ref="map"
        >
        </GmapMap>
    </div>
</template>

<script>
    import { loadGmapApi } from 'vue2-google-maps';
    import gmapcluster from 'vue2-google-maps/src/components/cluster';

    export default {
        props: ['position'],
        components: {
            gmapcluster,
        },
        data() {
            return {
                map:null,
                mapOptions: {
                    mapTypeControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                },
                shapeStyle: {
                    fillColor: "#c4413e",
                    fillOpacity: 0.4,
                    strokeColor: "#841d1b",
                    strokeWeight: 3,
                    editable: false
                },
                centerMap: {},
                markers: [],
                    clusterStyle: [{
                        textColor: 'black',
                        textSize: 12,
                        url: '/images/cluster/cluster_75.png',
                        height: 70,
                        width: 70
                    },
                    {
                        textColor: 'black',
                        textSize: 13,
                        url: '/images/cluster/cluster_85.png',
                        height: 80,
                        width: 80
                    }
                ],
                zoom: 17,
                geometryType: 'Point',
                polygonCoordinates: [],
                circleRadius: 0
            };
        },
        beforeMount() {
            // Controllo di non aver già caricato la mappa
            if(! this.$root.mapLoaded){
                // Carico lo script di gmaps
                loadGmapApi({
                    key: this.$root.host ? this.$root.host.google_maps_key : null,
                    libraries: 'places,drawing',
                });
                // Imposto la mappa come caricata
                this.$root.mapLoaded = true;
            }
        },
        mounted() {

            let mapCenter;

            this.geometryType = this.position.position.geometry.type;

            if (this.position.position.geometry.type==="Polygon") {
                mapCenter = {
                    lat:this.position.position.properties.center.coordinates[1],
                    lng:this.position.position.properties.center.coordinates[0]
                };
            }
            else {
                mapCenter = {
                    lat:this.position.position.geometry.coordinates[1],
                    lng:this.position.position.geometry.coordinates[0]
                };
            }

            this.centerMap = mapCenter;
            this.markers.push(mapCenter);

            this.$refs.map.$mapPromise.then((map) => {
                this.map = map;

                if (this.position.position.geometry.type==="Polygon"){

                    this.polygonCoordinates = this.position.position.geometry.coordinates[0].map(function(x) {
                        return {
                            lng: x[0],
                            lat: x[1]
                        };
                    });

                    // Construct the polygon.
                    const polygonProperty = new google.maps.Polygon({
                        paths: this.polygonCoordinates,
                        options:this.shapeStyle,
                    });
                    polygonProperty.setMap(map);

                    let bounds = new google.maps.LatLngBounds();

                    let i;

                    for (i = 0; i < this.polygonCoordinates.length; i++) {
                        bounds.extend(this.polygonCoordinates[i]);
                    }

                    this.centerMap = bounds.getCenter();
                    this.map.fitBounds(bounds);
                }
                else if (("radius" in this.position.position.properties) && this.position.position.properties.radius !== null){
                    this.geometryType = 'Circle'

                    const circleProperty = new google.maps.Circle({
                        options:this.shapeStyle,
                        radius: this.position.position.properties.radius,
                        map,
                        center: this.centerMap,
                    });

                    let bounds = new google.maps.LatLngBounds();

                    bounds.union(circleProperty.getBounds());

                    this.map.fitBounds(bounds,0);
                }
                else {
                    let self = this;

                    this.markers.forEach(function (marker){
                        new google.maps.Marker({
                            position: marker,
                            map,
                            options:self.shapeStyle,
                            // title: "Hello World!",
                        });
                    })

                }
            })

        },
    }
</script>
